import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: "insert",

  contrNo: null,
  sprName: null,
  quotNo: null,

  updateFields: [],
};

export const salesSlice = createSlice({
  name: "sales",
  initialState,
  reducers: {
    updateBasicInfo: (state, action) => {
      return {
        ...state,
        contrNo: action.payload.contrNo,
        sprName: action.payload.sprName,
        quotNo: action.payload.quotNo,
        updateFields: [...state.updateFields, "contrNo"],
      };
    },
  },
});

export const { updateBasicInfo, updateDuration } = salesSlice.actions;

export default salesSlice.reducer;
